module.exports = __webpack_public_path__ + "img/blindbox-active.2a860824.png";